import { render, staticRenderFns } from "./Productionsafety.vue?vue&type=template&id=5cbc9339&scoped=true&"
import script from "./Productionsafety.vue?vue&type=script&lang=js&"
export * from "./Productionsafety.vue?vue&type=script&lang=js&"
import style0 from "./Productionsafety.vue?vue&type=style&index=0&id=5cbc9339&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbc9339",
  null
  
)

export default component.exports